import {
  isEmpty,
  forbiddenCharacters,
  validateLength,
} from '../utility/validation';

export const NEW_SKILL_VALUES = {
  name: '',
};

export const SKILL_FIELDS = [
  {
    name: 'name',
    required: true,
    translationKey: 'skill',
    validators: [
      {
        validator: isEmpty,
        type: 'required',
      },
      {
        validator: forbiddenCharacters,
        type: 'forbiddenCharacters',
      },
      {
        validator: value => validateLength(value, 0, 255),
        type: 'maxLength',
      },
    ],
  },
];
